import React from 'react';
import './index.less'

const GlobalFooter = () => {
    return <footer className="footer">
        <div className="copyright">鲁班软件股份有限公司版权所有 沪ICP备 09024855号-28</div>
    </footer>
}

export default GlobalFooter;